/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * DEPRECATED, PLEASE DO NOT USE.
 * Default values can now be based on either light or legacy-light themes, whereas this only contains light theme values.
 *
 * Token names mapped to their value in the default Atlassian themes ('light').
 * These default values are used by the Babel plugin to optionally provide automatic fallbacks.
 *
 * @codegen <<SignedSource::a18a0cf6bb63fbd882dcfe06ef046047>>
 * @codegenCommand yarn build tokens
 */
const defaultTokenValues = {
	'motion.content.enter.long': '400ms cubic-bezier(0.66, 0, 0.34, 1) FadeIn',
	'motion.content.enter.medium': '200ms cubic-bezier(0.66, 0, 0.34, 1) FadeIn',
	'motion.content.enter.short': '100ms cubic-bezier(0.66, 0, 0.34, 1) FadeIn',
	'motion.content.exit.long': '200ms cubic-bezier(0.66, 0, 0.34, 1) FadeOut',
	'motion.content.exit.medium': '100ms cubic-bezier(0.66, 0, 0.34, 1) FadeOut',
	'motion.content.exit.short': '50ms cubic-bezier(0.66, 0, 0.34, 1) FadeOut',
	'motion.dialog.enter':
		'350ms cubic-bezier(0.66, 0, 0.34, 1) ScaleIn80, 350ms cubic-bezier(0.66, 0, 0.34, 1) FadeIn',
	'motion.dialog.exit':
		'350ms cubic-bezier(0.66, 0, 0.34, 1) ScaleOut80, 350ms cubic-bezier(0.66, 0, 0.34, 1) FadeOut',
	'color.text': '#292A2E',
	'color.text.accent.lime': '#4C6B1F',
	'color.text.accent.lime.bolder': '#37471F',
	'color.text.accent.red': '#AE2E24',
	'color.text.accent.red.bolder': '#5D1F1A',
	'color.text.accent.orange': '#9E4C00',
	'color.text.accent.orange.bolder': '#693200',
	'color.text.accent.yellow': '#7F5F01',
	'color.text.accent.yellow.bolder': '#533F04',
	'color.text.accent.green': '#216E4E',
	'color.text.accent.green.bolder': '#164B35',
	'color.text.accent.teal': '#206A83',
	'color.text.accent.teal.bolder': '#164555',
	'color.text.accent.blue': '#1558BC',
	'color.text.accent.blue.bolder': '#123263',
	'color.text.accent.purple': '#803FA5',
	'color.text.accent.purple.bolder': '#48245D',
	'color.text.accent.magenta': '#943D73',
	'color.text.accent.magenta.bolder': '#50253F',
	'color.text.accent.gray': '#505258',
	'color.text.accent.gray.bolder': '#1E1F21',
	'color.text.disabled': '#080F214A',
	'color.text.inverse': '#FFFFFF',
	'color.text.selected': '#1868DB',
	'color.text.brand': '#1868DB',
	'color.text.danger': '#AE2E24',
	'color.text.danger.bolder': '#5D1F1A',
	'color.text.warning': '#9E4C00',
	'color.text.warning.inverse': '#292A2E',
	'color.text.warning.bolder': '#693200',
	'color.text.success': '#4C6B1F',
	'color.text.success.bolder': '#37471F',
	'color.text.discovery': '#803FA5',
	'color.text.discovery.bolder': '#48245D',
	'color.text.information': '#1558BC',
	'color.text.information.bolder': '#123263',
	'color.text.subtlest': '#6B6E76',
	'color.text.subtle': '#505258',
	'color.link': '#1868DB',
	'color.link.pressed': '#1558BC',
	'color.link.visited': '#803FA5',
	'color.link.visited.pressed': '#48245D',
	'color.icon': '#292A2E',
	'color.icon.accent.lime': '#6A9A23',
	'color.icon.accent.red': '#C9372C',
	'color.icon.accent.orange': '#E06C00',
	'color.icon.accent.yellow': '#B38600',
	'color.icon.accent.green': '#22A06B',
	'color.icon.accent.teal': '#2898BD',
	'color.icon.accent.blue': '#357DE8',
	'color.icon.accent.purple': '#AF59E1',
	'color.icon.accent.magenta': '#CD519D',
	'color.icon.accent.gray': '#7D818A',
	'color.icon.disabled': '#080F214A',
	'color.icon.inverse': '#FFFFFF',
	'color.icon.selected': '#1868DB',
	'color.icon.brand': '#1868DB',
	'color.icon.danger': '#C9372C',
	'color.icon.warning': '#E06C00',
	'color.icon.warning.inverse': '#292A2E',
	'color.icon.success': '#6A9A23',
	'color.icon.discovery': '#AF59E1',
	'color.icon.information': '#357DE8',
	'color.icon.subtlest': '#6B6E76',
	'color.icon.subtle': '#505258',
	'color.border': '#0B120E24',
	'color.border.accent.lime': '#6A9A23',
	'color.border.accent.red': '#E2483D',
	'color.border.accent.orange': '#E06C00',
	'color.border.accent.yellow': '#B38600',
	'color.border.accent.green': '#22A06B',
	'color.border.accent.teal': '#2898BD',
	'color.border.accent.blue': '#357DE8',
	'color.border.accent.purple': '#AF59E1',
	'color.border.accent.magenta': '#CD519D',
	'color.border.accent.gray': '#7D818A',
	'color.border.disabled': '#0515240F',
	'color.border.focused': '#4688EC',
	'color.border.input': '#8C8F97',
	'color.border.inverse': '#FFFFFF',
	'color.border.selected': '#1868DB',
	'color.border.brand': '#1868DB',
	'color.border.danger': '#E2483D',
	'color.border.warning': '#E06C00',
	'color.border.success': '#6A9A23',
	'color.border.discovery': '#AF59E1',
	'color.border.information': '#357DE8',
	'color.border.bold': '#7D818A',
	'color.background.accent.lime.subtlest': '#EFFFD6',
	'color.background.accent.lime.subtlest.hovered': '#D3F1A7',
	'color.background.accent.lime.subtlest.pressed': '#BDE97C',
	'color.background.accent.lime.subtler': '#D3F1A7',
	'color.background.accent.lime.subtler.hovered': '#BDE97C',
	'color.background.accent.lime.subtler.pressed': '#B3DF72',
	'color.background.accent.lime.subtle': '#94C748',
	'color.background.accent.lime.subtle.hovered': '#B3DF72',
	'color.background.accent.lime.subtle.pressed': '#BDE97C',
	'color.background.accent.lime.bolder': '#5B7F24',
	'color.background.accent.lime.bolder.hovered': '#4C6B1F',
	'color.background.accent.lime.bolder.pressed': '#3F5224',
	'color.background.accent.red.subtlest': '#FFECEB',
	'color.background.accent.red.subtlest.hovered': '#FFD5D2',
	'color.background.accent.red.subtlest.pressed': '#FFB8B2',
	'color.background.accent.red.subtler': '#FFD5D2',
	'color.background.accent.red.subtler.hovered': '#FFB8B2',
	'color.background.accent.red.subtler.pressed': '#FD9891',
	'color.background.accent.red.subtle': '#F87168',
	'color.background.accent.red.subtle.hovered': '#FD9891',
	'color.background.accent.red.subtle.pressed': '#FFB8B2',
	'color.background.accent.red.bolder': '#C9372C',
	'color.background.accent.red.bolder.hovered': '#AE2E24',
	'color.background.accent.red.bolder.pressed': '#872821',
	'color.background.accent.orange.subtlest': '#FFF5DB',
	'color.background.accent.orange.subtlest.hovered': '#FCE4A6',
	'color.background.accent.orange.subtlest.pressed': '#FBD779',
	'color.background.accent.orange.subtler': '#FCE4A6',
	'color.background.accent.orange.subtler.hovered': '#FBD779',
	'color.background.accent.orange.subtler.pressed': '#FBC828',
	'color.background.accent.orange.subtle': '#FCA700',
	'color.background.accent.orange.subtle.hovered': '#FBC828',
	'color.background.accent.orange.subtle.pressed': '#FBD779',
	'color.background.accent.orange.bolder': '#BD5B00',
	'color.background.accent.orange.bolder.hovered': '#9E4C00',
	'color.background.accent.orange.bolder.pressed': '#7A3B00',
	'color.background.accent.yellow.subtlest': '#FEF7C8',
	'color.background.accent.yellow.subtlest.hovered': '#F5E989',
	'color.background.accent.yellow.subtlest.pressed': '#EFDD4E',
	'color.background.accent.yellow.subtler': '#F5E989',
	'color.background.accent.yellow.subtler.hovered': '#EFDD4E',
	'color.background.accent.yellow.subtler.pressed': '#EED12B',
	'color.background.accent.yellow.subtle': '#EED12B',
	'color.background.accent.yellow.subtle.hovered': '#DDB30E',
	'color.background.accent.yellow.subtle.pressed': '#EFDD4E',
	'color.background.accent.yellow.bolder': '#946F00',
	'color.background.accent.yellow.bolder.hovered': '#7F5F01',
	'color.background.accent.yellow.bolder.pressed': '#614A05',
	'color.background.accent.green.subtlest': '#DCFFF1',
	'color.background.accent.green.subtlest.hovered': '#BAF3DB',
	'color.background.accent.green.subtlest.pressed': '#97EDC9',
	'color.background.accent.green.subtler': '#BAF3DB',
	'color.background.accent.green.subtler.hovered': '#97EDC9',
	'color.background.accent.green.subtler.pressed': '#7EE2B8',
	'color.background.accent.green.subtle': '#4BCE97',
	'color.background.accent.green.subtle.hovered': '#7EE2B8',
	'color.background.accent.green.subtle.pressed': '#97EDC9',
	'color.background.accent.green.bolder': '#1F845A',
	'color.background.accent.green.bolder.hovered': '#216E4E',
	'color.background.accent.green.bolder.pressed': '#19573D',
	'color.background.accent.teal.subtlest': '#E7F9FF',
	'color.background.accent.teal.subtlest.hovered': '#C6EDFB',
	'color.background.accent.teal.subtlest.pressed': '#B1E4F7',
	'color.background.accent.teal.subtler': '#C6EDFB',
	'color.background.accent.teal.subtler.hovered': '#B1E4F7',
	'color.background.accent.teal.subtler.pressed': '#9DD9EE',
	'color.background.accent.teal.subtle': '#6CC3E0',
	'color.background.accent.teal.subtle.hovered': '#9DD9EE',
	'color.background.accent.teal.subtle.pressed': '#B1E4F7',
	'color.background.accent.teal.bolder': '#227D9B',
	'color.background.accent.teal.bolder.hovered': '#206A83',
	'color.background.accent.teal.bolder.pressed': '#1A5265',
	'color.background.accent.blue.subtlest': '#E9F2FE',
	'color.background.accent.blue.subtlest.hovered': '#CFE1FD',
	'color.background.accent.blue.subtlest.pressed': '#ADCBFB',
	'color.background.accent.blue.subtler': '#CFE1FD',
	'color.background.accent.blue.subtler.hovered': '#ADCBFB',
	'color.background.accent.blue.subtler.pressed': '#8FB8F6',
	'color.background.accent.blue.subtle': '#669DF1',
	'color.background.accent.blue.subtle.hovered': '#8FB8F6',
	'color.background.accent.blue.subtle.pressed': '#ADCBFB',
	'color.background.accent.blue.bolder': '#1868DB',
	'color.background.accent.blue.bolder.hovered': '#1558BC',
	'color.background.accent.blue.bolder.pressed': '#144794',
	'color.background.accent.purple.subtlest': '#F8EEFE',
	'color.background.accent.purple.subtlest.hovered': '#EED7FC',
	'color.background.accent.purple.subtlest.pressed': '#E3BDFA',
	'color.background.accent.purple.subtler': '#EED7FC',
	'color.background.accent.purple.subtler.hovered': '#E3BDFA',
	'color.background.accent.purple.subtler.pressed': '#D8A0F7',
	'color.background.accent.purple.subtle': '#C97CF4',
	'color.background.accent.purple.subtle.hovered': '#D8A0F7',
	'color.background.accent.purple.subtle.pressed': '#E3BDFA',
	'color.background.accent.purple.bolder': '#964AC0',
	'color.background.accent.purple.bolder.hovered': '#803FA5',
	'color.background.accent.purple.bolder.pressed': '#673286',
	'color.background.accent.magenta.subtlest': '#FFECF8',
	'color.background.accent.magenta.subtlest.hovered': '#FDD0EC',
	'color.background.accent.magenta.subtlest.pressed': '#FCB6E1',
	'color.background.accent.magenta.subtler': '#FDD0EC',
	'color.background.accent.magenta.subtler.hovered': '#FCB6E1',
	'color.background.accent.magenta.subtler.pressed': '#F797D2',
	'color.background.accent.magenta.subtle': '#E774BB',
	'color.background.accent.magenta.subtle.hovered': '#F797D2',
	'color.background.accent.magenta.subtle.pressed': '#FCB6E1',
	'color.background.accent.magenta.bolder': '#AE4787',
	'color.background.accent.magenta.bolder.hovered': '#943D73',
	'color.background.accent.magenta.bolder.pressed': '#77325B',
	'color.background.accent.gray.subtlest': '#F0F1F2',
	'color.background.accent.gray.subtlest.hovered': '#DDDEE1',
	'color.background.accent.gray.subtlest.pressed': '#B7B9BE',
	'color.background.accent.gray.subtler': '#DDDEE1',
	'color.background.accent.gray.subtler.hovered': '#B7B9BE',
	'color.background.accent.gray.subtler.pressed': '#8C8F97',
	'color.background.accent.gray.subtle': '#8C8F97',
	'color.background.accent.gray.subtle.hovered': '#B7B9BE',
	'color.background.accent.gray.subtle.pressed': '#DDDEE1',
	'color.background.accent.gray.bolder': '#6B6E76',
	'color.background.accent.gray.bolder.hovered': '#505258',
	'color.background.accent.gray.bolder.pressed': '#3B3D42',
	'color.background.disabled': '#17171708',
	'color.background.input': '#FFFFFF',
	'color.background.input.hovered': '#F8F8F8',
	'color.background.input.pressed': '#FFFFFF',
	'color.background.inverse.subtle': '#00000029',
	'color.background.inverse.subtle.hovered': '#0000003D',
	'color.background.inverse.subtle.pressed': '#00000052',
	'color.background.neutral': '#0515240F',
	'color.background.neutral.hovered': '#0B120E24',
	'color.background.neutral.pressed': '#080F214A',
	'color.background.neutral.subtle': '#00000000',
	'color.background.neutral.subtle.hovered': '#0515240F',
	'color.background.neutral.subtle.pressed': '#0B120E24',
	'color.background.neutral.bold': '#292A2E',
	'color.background.neutral.bold.hovered': '#3B3D42',
	'color.background.neutral.bold.pressed': '#505258',
	'color.background.selected': '#E9F2FE',
	'color.background.selected.hovered': '#CFE1FD',
	'color.background.selected.pressed': '#8FB8F6',
	'color.background.selected.bold': '#1868DB',
	'color.background.selected.bold.hovered': '#1558BC',
	'color.background.selected.bold.pressed': '#123263',
	'color.background.brand.subtlest': '#E9F2FE',
	'color.background.brand.subtlest.hovered': '#CFE1FD',
	'color.background.brand.subtlest.pressed': '#ADCBFB',
	'color.background.brand.bold': '#1868DB',
	'color.background.brand.bold.hovered': '#1558BC',
	'color.background.brand.bold.pressed': '#144794',
	'color.background.brand.boldest': '#1C2B42',
	'color.background.brand.boldest.hovered': '#123263',
	'color.background.brand.boldest.pressed': '#144794',
	'color.background.danger': '#FFECEB',
	'color.background.danger.hovered': '#FFD5D2',
	'color.background.danger.pressed': '#FFB8B2',
	'color.background.danger.subtler': '#FFD5D2',
	'color.background.danger.subtler.hovered': '#FFB8B2',
	'color.background.danger.subtler.pressed': '#FD9891',
	'color.background.danger.bold': '#C9372C',
	'color.background.danger.bold.hovered': '#AE2E24',
	'color.background.danger.bold.pressed': '#872821',
	'color.background.warning': '#FFF5DB',
	'color.background.warning.hovered': '#FCE4A6',
	'color.background.warning.pressed': '#FBD779',
	'color.background.warning.subtler': '#FCE4A6',
	'color.background.warning.subtler.hovered': '#FBD779',
	'color.background.warning.subtler.pressed': '#FBC828',
	'color.background.warning.bold': '#FBC828',
	'color.background.warning.bold.hovered': '#FCA700',
	'color.background.warning.bold.pressed': '#F68909',
	'color.background.success': '#EFFFD6',
	'color.background.success.hovered': '#D3F1A7',
	'color.background.success.pressed': '#BDE97C',
	'color.background.success.subtler': '#D3F1A7',
	'color.background.success.subtler.hovered': '#BDE97C',
	'color.background.success.subtler.pressed': '#B3DF72',
	'color.background.success.bold': '#5B7F24',
	'color.background.success.bold.hovered': '#4C6B1F',
	'color.background.success.bold.pressed': '#3F5224',
	'color.background.discovery': '#F8EEFE',
	'color.background.discovery.hovered': '#EED7FC',
	'color.background.discovery.pressed': '#E3BDFA',
	'color.background.discovery.subtler': '#EED7FC',
	'color.background.discovery.subtler.hovered': '#E3BDFA',
	'color.background.discovery.subtler.pressed': '#D8A0F7',
	'color.background.discovery.bold': '#964AC0',
	'color.background.discovery.bold.hovered': '#803FA5',
	'color.background.discovery.bold.pressed': '#673286',
	'color.background.information': '#E9F2FE',
	'color.background.information.hovered': '#CFE1FD',
	'color.background.information.pressed': '#ADCBFB',
	'color.background.information.subtler': '#CFE1FD',
	'color.background.information.subtler.hovered': '#ADCBFB',
	'color.background.information.subtler.pressed': '#8FB8F6',
	'color.background.information.bold': '#1868DB',
	'color.background.information.bold.hovered': '#1558BC',
	'color.background.information.bold.pressed': '#144794',
	'color.blanket': '#050C1F75',
	'color.blanket.selected': '#388BFF14',
	'color.blanket.danger': '#EF5C4814',
	'color.interaction.hovered': '#00000029',
	'color.interaction.pressed': '#00000052',
	'color.skeleton': '#0515240F',
	'color.skeleton.subtle': '#17171708',
	'color.chart.categorical.1': '#357DE8',
	'color.chart.categorical.1.hovered': '#1868DB',
	'color.chart.categorical.2': '#82B536',
	'color.chart.categorical.2.hovered': '#6A9A23',
	'color.chart.categorical.3': '#BF63F3',
	'color.chart.categorical.3.hovered': '#AF59E1',
	'color.chart.categorical.4': '#F68909',
	'color.chart.categorical.4.hovered': '#E06C00',
	'color.chart.categorical.5': '#1558BC',
	'color.chart.categorical.5.hovered': '#123263',
	'color.chart.categorical.6': '#964AC0',
	'color.chart.categorical.6.hovered': '#803FA5',
	'color.chart.categorical.7': '#42B2D7',
	'color.chart.categorical.7.hovered': '#2898BD',
	'color.chart.categorical.8': '#BD5B00',
	'color.chart.categorical.8.hovered': '#7A3B00',
	'color.chart.lime.bold': '#6A9A23',
	'color.chart.lime.bold.hovered': '#5B7F24',
	'color.chart.lime.bolder': '#5B7F24',
	'color.chart.lime.bolder.hovered': '#4C6B1F',
	'color.chart.lime.boldest': '#4C6B1F',
	'color.chart.lime.boldest.hovered': '#37471F',
	'color.chart.neutral': '#8C8F97',
	'color.chart.neutral.hovered': '#7D818A',
	'color.chart.red.bold': '#F15B50',
	'color.chart.red.bold.hovered': '#E2483D',
	'color.chart.red.bolder': '#E2483D',
	'color.chart.red.bolder.hovered': '#C9372C',
	'color.chart.red.boldest': '#AE2E24',
	'color.chart.red.boldest.hovered': '#5D1F1A',
	'color.chart.orange.bold': '#E06C00',
	'color.chart.orange.bold.hovered': '#BD5B00',
	'color.chart.orange.bolder': '#BD5B00',
	'color.chart.orange.bolder.hovered': '#9E4C00',
	'color.chart.orange.boldest': '#7A3B00',
	'color.chart.orange.boldest.hovered': '#693200',
	'color.chart.yellow.bold': '#B38600',
	'color.chart.yellow.bold.hovered': '#946F00',
	'color.chart.yellow.bolder': '#946F00',
	'color.chart.yellow.bolder.hovered': '#7F5F01',
	'color.chart.yellow.boldest': '#7F5F01',
	'color.chart.yellow.boldest.hovered': '#533F04',
	'color.chart.green.bold': '#22A06B',
	'color.chart.green.bold.hovered': '#1F845A',
	'color.chart.green.bolder': '#1F845A',
	'color.chart.green.bolder.hovered': '#216E4E',
	'color.chart.green.boldest': '#216E4E',
	'color.chart.green.boldest.hovered': '#164B35',
	'color.chart.teal.bold': '#2898BD',
	'color.chart.teal.bold.hovered': '#227D9B',
	'color.chart.teal.bolder': '#227D9B',
	'color.chart.teal.bolder.hovered': '#206A83',
	'color.chart.teal.boldest': '#206A83',
	'color.chart.teal.boldest.hovered': '#164555',
	'color.chart.blue.bold': '#4688EC',
	'color.chart.blue.bold.hovered': '#357DE8',
	'color.chart.blue.bolder': '#357DE8',
	'color.chart.blue.bolder.hovered': '#1868DB',
	'color.chart.blue.boldest': '#1558BC',
	'color.chart.blue.boldest.hovered': '#123263',
	'color.chart.purple.bold': '#BF63F3',
	'color.chart.purple.bold.hovered': '#AF59E1',
	'color.chart.purple.bolder': '#AF59E1',
	'color.chart.purple.bolder.hovered': '#964AC0',
	'color.chart.purple.boldest': '#803FA5',
	'color.chart.purple.boldest.hovered': '#48245D',
	'color.chart.magenta.bold': '#DA62AC',
	'color.chart.magenta.bold.hovered': '#CD519D',
	'color.chart.magenta.bolder': '#CD519D',
	'color.chart.magenta.bolder.hovered': '#AE4787',
	'color.chart.magenta.boldest': '#943D73',
	'color.chart.magenta.boldest.hovered': '#50253F',
	'color.chart.gray.bold': '#8C8F97',
	'color.chart.gray.bold.hovered': '#7D818A',
	'color.chart.gray.bolder': '#7D818A',
	'color.chart.gray.bolder.hovered': '#6B6E76',
	'color.chart.gray.boldest': '#505258',
	'color.chart.gray.boldest.hovered': '#3B3D42',
	'color.chart.brand': '#357DE8',
	'color.chart.brand.hovered': '#1868DB',
	'color.chart.danger': '#E2483D',
	'color.chart.danger.hovered': '#C9372C',
	'color.chart.danger.bold': '#872821',
	'color.chart.danger.bold.hovered': '#5D1F1A',
	'color.chart.warning': '#F68909',
	'color.chart.warning.hovered': '#E06C00',
	'color.chart.warning.bold': '#BD5B00',
	'color.chart.warning.bold.hovered': '#9E4C00',
	'color.chart.success': '#82B536',
	'color.chart.success.hovered': '#6A9A23',
	'color.chart.success.bold': '#5B7F24',
	'color.chart.success.bold.hovered': '#4C6B1F',
	'color.chart.discovery': '#BF63F3',
	'color.chart.discovery.hovered': '#AF59E1',
	'color.chart.discovery.bold': '#803FA5',
	'color.chart.discovery.bold.hovered': '#964AC0',
	'color.chart.information': '#357DE8',
	'color.chart.information.hovered': '#1868DB',
	'color.chart.information.bold': '#1558BC',
	'color.chart.information.bold.hovered': '#123263',
	'elevation.surface': '#FFFFFF',
	'elevation.surface.hovered': '#F0F1F2',
	'elevation.surface.pressed': '#DDDEE1',
	'elevation.surface.overlay': '#FFFFFF',
	'elevation.surface.overlay.hovered': '#F0F1F2',
	'elevation.surface.overlay.pressed': '#DDDEE1',
	'elevation.surface.raised': '#FFFFFF',
	'elevation.surface.raised.hovered': '#F0F1F2',
	'elevation.surface.raised.pressed': '#DDDEE1',
	'elevation.surface.sunken': '#F8F8F8',
	'elevation.shadow.overflow': '0px 0px 8px #1E1F2129, 0px 0px 1px #1E1F211F',
	'elevation.shadow.overflow.perimeter': '#1E1F211f',
	'elevation.shadow.overflow.spread': '#1E1F2129',
	'elevation.shadow.overlay': '0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214F',
	'elevation.shadow.raised': '0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214F',
	'opacity.disabled': '0.4',
	'opacity.loading': '0.2',
	'utility.UNSAFE.transparent': 'transparent',
	'utility.elevation.surface.current': '#FFFFFF',
	'space.0': '0rem',
	'space.025': '0.125rem',
	'space.050': '0.25rem',
	'space.075': '0.375rem',
	'space.100': '0.5rem',
	'space.150': '0.75rem',
	'space.200': '1rem',
	'space.250': '1.25rem',
	'space.300': '1.5rem',
	'space.400': '2rem',
	'space.500': '2.5rem',
	'space.600': '3rem',
	'space.800': '4rem',
	'space.1000': '5rem',
	'space.negative.025': '-0.125rem',
	'space.negative.050': '-0.25rem',
	'space.negative.075': '-0.375rem',
	'space.negative.100': '-0.5rem',
	'space.negative.150': '-0.75rem',
	'space.negative.200': '-1rem',
	'space.negative.250': '-1.25rem',
	'space.negative.300': '-1.5rem',
	'space.negative.400': '-2rem',
	'font.heading.xxlarge':
		'normal 653 2rem/2.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.heading.xlarge':
		'normal 653 1.75rem/2rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.heading.large':
		'normal 653 1.5rem/1.75rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.heading.medium':
		'normal 653 1.25rem/1.5rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.heading.small':
		'normal 653 1rem/1.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.heading.xsmall':
		'normal 653 0.875rem/1.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.heading.xxsmall':
		'normal 653 0.75rem/1rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.body.large':
		'normal 400 1rem/1.5rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.body':
		'normal 400 0.875rem/1.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.body.small':
		'normal 400 0.75rem/1rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.body.UNSAFE_small':
		'normal 400 0.75rem/1rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.metric.large':
		'normal 653 1.75rem/2rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.metric.medium':
		'normal 653 1.5rem/1.75rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.metric.small':
		'normal 653 1rem/1.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.code':
		'normal 400 0.875em/1 "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace',
	'font.weight.regular': '400',
	'font.weight.medium': '500',
	'font.weight.semibold': '600',
	'font.weight.bold': '653',
	'font.family.heading':
		'"Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.family.body':
		'"Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.family.code':
		'"Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace',
	'font.family.brand.heading':
		'"Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'font.family.brand.body':
		'"Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	'radius.xsmall': '0.125rem',
	'radius.small': '0.25rem',
	'radius.medium': '0.375rem',
	'radius.large': '0.5rem',
	'radius.xlarge': '0.75rem',
	'radius.xxlarge': '1rem',
	'radius.full': '624.9375rem',
	'radius.tile': '25%',
	'border.width': '0.0625rem',
	'border.width.selected': '0.125rem',
	'border.width.focused': '0.125rem',
} as const;

export default defaultTokenValues;
